export default __webpack_public_path__ + "static/image-5-mob-28db3eacecd7f1cfe05091c2e16fdbd1.jpg";